import Resource from '@/api/Resource';
import User from '@/models/User';
import Platform from '@/models/Platform';
import TaskStatus from '@/models/TaskStatus';
import TaskFile from '@/models/TaskFile';
import TaskMessage from '@/models/TaskMessage';

export default class extends Resource {
  $name = 'tasks';

  $defaults() {
    return {
      id: null,
      active: 1,
      status_id: 0,
      label_id: 0,
      author_id: 0,
      executor_id: 0,
      platform_id: 0,
      priority: 0,
      is_team: 0,
      team_status: null,
      team_status_label: null,
      title: '',
      body: '',
      support_comment: '',
      begin_at: null,
      finish_at: null,
      deadline_at: null,
      updated_at: null,
      created_at: null,

      files: null,
      tags: null,
    };
  }

  $fill({ status, author, platform, files, allFiles, messages, executor, deadline_at }) {
    if (status) {
      this.status = new TaskStatus(status);
    }
    if (author) {
      this.author = new User(author);
    }
    if (executor) {
      this.executor = new User(executor);
    }
    if (platform) {
      this.platform = new Platform(platform);
    }
    if (files) {
      this.files = TaskFile.collection(files);
    }
    if (allFiles) {
      this.allFiles = TaskFile.collection(allFiles);
    }
    if (messages) {
      this.messages = TaskMessage.collection(messages);
    }
    if (deadline_at) {
      this.deadline_at = new Date(deadline_at);
    }
  }

  get allFilesCount() {
    return this.allFiles ? this.allFiles.count() : 0;
  }

  get messagesCount() {
    return this.messages ? this.messages.count() : 0;
  }

  get platformName() {
    return this.platform ? this.platform.name : '';
  }

  get lastMessage() {
    if (this.messages && this.messages.count()) {
      return this.messages.last();
    }
  }

  get lastActivityUser() {
    return this.lastMessage ? this.lastMessage.user : this.user;
  }

  get lastActivity() {
    return this.lastMessage ? this.lastMessage.created_at : this.created_at;
  }
}
